// aws-exports.js
export default{
    cognito: {
        REGION: process.env.REACT_APP_REGION,
        USER_POOL_ID: process.env.REACT_APP_SELLER_COGNITO_USERPOOL_ID,
        APP_CLIENT_ID: process.env.REACT_APP_SELLER_COGNITO_CLIENT_ID,
        AUTHENTICATION_TYPE: 'USER_PASSWORD_AUTH',
        IDENTITY_POOL_ID: process.env.REACT_APP_SELLER_COGNITO_IDENTITY_POOL_ID,
    },
    API: {
        baseURL: process.env.REACT_APP_DOMAIN_NAME_FRONT_END+"/v1",
        mailchimpURL: process.env.REACT_APP_MAILCHIMP_API,
        googleTimeZoneAPI: process.env.REACT_APP_GOOGLE_TIMEZONE_API,
    },
    Storage: {
        bucket: process.env.REACT_APP_BUCKET_NAME,
        region: process.env.REACT_APP_REGION,
        CDN: process.env.REACT_APP_CDN_URL,
        kmsKeyId: process.env.REACT_APP_ASSETS_BUCKET_KMS_KEY_ARN,
    },
    Environment: {
        url: process.env.REACT_APP_STAGE,
        auctionUrl: process.env.REACT_APP_BASE_URL_BUYER+"/",
        domain: process.env.REACT_APP_AMPLIFY_DOMAIN_NAME,
        stage: process.env.REACT_APP_STAGE
    },
    GOOGLETIMEZONEAPIKEY: process.env.REACT_APP_GOOGLE_TIMEZONE_API_KEY,
    GOOGLEAPIKEY: process.env.REACT_APP_GOOGLE_API_KEY,
    SITEKEY: process.env.REACT_APP_SITEKEY,
    SOCKETURL: process.env.REACT_APP_SOCKET_URL,
    OpenReplay: {
        projectKey: process.env.REACT_APP_OPENREPLAY_PROJECT_KEY,
        ingestPoint: process.env.REACT_APP_OPENREPLAY_INGEST_POINT
    }
};
